import {
  DELETE_DEPARTMENT_FAILURE,
  DELETE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_SUCCESS,
  GET_ALL_DEPARTMENT_LIST_FAILURE,
  GET_ALL_DEPARTMENT_LIST_REQUEST,
  GET_ALL_DEPARTMENT_LIST_SUCCESS,
  POST_DEPARTMENT_FAILURE,
  POST_DEPARTMENT_REQUEST,
  POST_DEPARTMENT_SUCCESS,
  PUT_DEPARTMENT_FAILURE,
  PUT_DEPARTMENT_REQUEST,
  PUT_DEPARTMENT_SUCCESS,

  DELETE_DEPARTMENT_CATEGORY_FAILURE,
  DELETE_DEPARTMENT_CATEGORY_REQUEST,
  DELETE_DEPARTMENT_CATEGORY_SUCCESS,
  GET_ALL_DEPARTMENT_CATEGORY_LIST_FAILURE,
  GET_ALL_DEPARTMENT_CATEGORY_LIST_REQUEST,
  GET_ALL_DEPARTMENT_CATEGORY_LIST_SUCCESS,
  POST_DEPARTMENT_CATEGORY_FAILURE,
  POST_DEPARTMENT_CATEGORY_REQUEST,
  POST_DEPARTMENT_CATEGORY_SUCCESS,
  PUT_DEPARTMENT_CATEGORY_FAILURE,
  PUT_DEPARTMENT_CATEGORY_REQUEST,
  PUT_DEPARTMENT_CATEGORY_SUCCESS,

  DELETE_DEPARTMENT_INVENTORY_FAILURE,
  DELETE_DEPARTMENT_INVENTORY_REQUEST,
  DELETE_DEPARTMENT_INVENTORY_SUCCESS,
  GET_ALL_DEPARTMENT_INVENTORY_LIST_FAILURE,
  GET_ALL_DEPARTMENT_INVENTORY_LIST_REQUEST,
  GET_ALL_DEPARTMENT_INVENTORY_LIST_SUCCESS,
  POST_DEPARTMENT_INVENTORY_FAILURE,
  POST_DEPARTMENT_INVENTORY_REQUEST,
  POST_DEPARTMENT_INVENTORY_SUCCESS,
  PUT_DEPARTMENT_INVENTORY_FAILURE,
  PUT_DEPARTMENT_INVENTORY_REQUEST,
  PUT_DEPARTMENT_INVENTORY_SUCCESS,
} from "../../../Utils/Constant";

// Get All Department List Details
export const getAllDepartmentListRequest = (payload) => {
  return {
    type: GET_ALL_DEPARTMENT_LIST_REQUEST,
    payload,
  };
};

export const getAllDepartmentListSuccess = (data) => {
  return {
    type: GET_ALL_DEPARTMENT_LIST_SUCCESS,
    payload: data,
  };
};

export const getAllDepartmentListFailure = (error) => {
  return {
    type: GET_ALL_DEPARTMENT_LIST_FAILURE,
    payload: error,
  };
};

export const addDepartmentRequest = (payload) => {
  return {
    type: POST_DEPARTMENT_REQUEST,
    payload,
  };
};

export const addDepartmentSuccess = (data) => {
  return {
    type: POST_DEPARTMENT_SUCCESS,
    payload: data,
  };
};

export const addDepartmentFailure = (error) => {
  return {
    type: POST_DEPARTMENT_FAILURE,
    payload: error,
  };
};

export const updateDepartmentRequest = (payload) => {
  return {
    type: PUT_DEPARTMENT_REQUEST,
    payload,
  };
};

export const updateDepartmentSuccess = (data) => {
  return {
    type: PUT_DEPARTMENT_SUCCESS,
    payload: data,
  };
};

export const updateDepartmentFailure = (error) => {
  return {
    type: PUT_DEPARTMENT_FAILURE,
    payload: error,
  };
};

export const deleteDepartmentRequest = (payload) => {
  return {
    type: DELETE_DEPARTMENT_REQUEST,
    payload,
  };
};

export const deleteDepartmentSuccess = (data) => {
  return {
    type: DELETE_DEPARTMENT_SUCCESS,
    payload: data,
  };
};

export const deleteDepartmentFailure = (error) => {
  return {
    type: DELETE_DEPARTMENT_FAILURE,
    payload: error,
  };
};


// Get All Department CATEGORY List Details
export const getAllDepartmentCategoryListRequest = (payload) => {
  return {
    type: GET_ALL_DEPARTMENT_CATEGORY_LIST_REQUEST,
    payload,
  };
};

export const getAllDepartmentCategoryListSuccess = (data) => {
  return {
    type: GET_ALL_DEPARTMENT_CATEGORY_LIST_SUCCESS,
    payload: data,
  };
};

export const getAllDepartmentCategoryListFailure = (error) => {
  return {
    type: GET_ALL_DEPARTMENT_CATEGORY_LIST_FAILURE,
    payload: error,
  };
};

export const addDepartmentCategoryRequest = (payload) => {
  return {
    type: POST_DEPARTMENT_CATEGORY_REQUEST,
    payload,
  };
};

export const addDepartmentCategorySuccess = (data) => {
  return {
    type: POST_DEPARTMENT_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const addDepartmentCategoryFailure = (error) => {
  return {
    type: POST_DEPARTMENT_CATEGORY_FAILURE,
    payload: error,
  };
};

export const updateDepartmentCategoryRequest = (payload) => {
  return {
    type: PUT_DEPARTMENT_CATEGORY_REQUEST,
    payload,
  };
};

export const updateDepartmentCategorySuccess = (data) => {
  return {
    type: PUT_DEPARTMENT_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const updateDepartmentCategoryFailure = (error) => {
  return {
    type: PUT_DEPARTMENT_CATEGORY_FAILURE,
    payload: error,
  };
};

export const deleteDepartmentCategoryRequest = (payload) => {
  return {
    type: DELETE_DEPARTMENT_CATEGORY_REQUEST,
    payload,
  };
};

export const deleteDepartmentCategorySuccess = (data) => {
  return {
    type: DELETE_DEPARTMENT_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const deleteDepartmentCategoryFailure = (error) => {
  return {
    type: DELETE_DEPARTMENT_CATEGORY_FAILURE,
    payload: error,
  };
};

// Inventory
export const getAllDepartmentInventoryListRequest = (payload) => {
  return {
    type: GET_ALL_DEPARTMENT_INVENTORY_LIST_REQUEST,
    payload,
  };
};

export const getAllDepartmentInventoryListSuccess = (data) => {
  return {
    type: GET_ALL_DEPARTMENT_INVENTORY_LIST_SUCCESS,
    payload: data,
  };
};

export const getAllDepartmentInventoryListFailure = (error) => {
  return {
    type: GET_ALL_DEPARTMENT_INVENTORY_LIST_FAILURE,
    payload: error,
  };
};

export const addDepartmentInventoryRequest = (payload) => {
  return {
    type: POST_DEPARTMENT_INVENTORY_REQUEST,
    payload,
  };
};

export const addDepartmentInventorySuccess = (data) => {
  return {
    type: POST_DEPARTMENT_INVENTORY_SUCCESS,
    payload: data,
  };
};

export const addDepartmentInventoryFailure = (error) => {
  return {
    type: POST_DEPARTMENT_INVENTORY_FAILURE,
    payload: error,
  };
};

export const updateDepartmentInventoryRequest = (payload) => {
  return {
    type: PUT_DEPARTMENT_INVENTORY_REQUEST,
    payload,
  };
};

export const updateDepartmentInventorySuccess = (data) => {
  return {
    type: PUT_DEPARTMENT_INVENTORY_SUCCESS,
    payload: data,
  };
};

export const updateDepartmentInventoryFailure = (error) => {
  return {
    type: PUT_DEPARTMENT_INVENTORY_FAILURE,
    payload: error,
  };
};

export const deleteDepartmentInventoryRequest = (payload) => {
  return {
    type: DELETE_DEPARTMENT_INVENTORY_REQUEST,
    payload,
  };
};

export const deleteDepartmentInventorySuccess = (data) => {
  return {
    type: DELETE_DEPARTMENT_INVENTORY_SUCCESS,
    payload: data,
  };
};

export const deleteDepartmentInventoryFailure = (error) => {
  return {
    type: DELETE_DEPARTMENT_INVENTORY_FAILURE,
    payload: error,
  };
};
